<template>
  <DialogButtonWithTooltip
    ref="dateModal"
    tooltipTop
    modalWidth="550px"
    :triggerButtonProps="{
      small: true,
      outlined: true,
      color: 'var(--goe-fontColor-darkish)'
    }"
    smallTriggerIcon
    iconName="mdi-close-octagon"
    :tooltipText="
      disabled ? 'Stoernieren nicht möglich' : 'Kündigung stornieren'
    "
    confirmButtonText="Kündigung stornieren"
    confirmButtonColor="warning"
    :confirmButtonDisabled="disabled"
    :disabled="disabled"
    :loading="submitting"
    :closeOnSubmit="false"
    persistent
    @onCancel="
      () => {
        newTerminationDate = null;
      }
    "
    @onAction="rejectTerminationProcess()"
  >
    <template v-slot:triggerButtonText> Stornieren </template>
    <template v-slot:dialogTitle> Kündigung Stornieren </template>
    <template v-slot:dialogText>
      <v-row class="mt-4 mb-2 mx-1">
        <span>
          Soll die Kündigung für Vertrag
          <strong>{{ processData.contractId }}</strong> storniert werden?
        </span>
      </v-row>
    </template>
  </DialogButtonWithTooltip>
</template>
<script>
import { HTTP } from '@/main/httpClient.js';
import DialogButtonWithTooltip from '@/components/elements/DialogButtonWithTooltip.vue';

import NotificationObject from '@/main/NotificationObject.js';
import { CAMUNDA } from '@/main/constants.js';

export default {
  name: 'RejectTermination',
  components: {
    DialogButtonWithTooltip
  },
  props: {
    processData: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    rejectTerminationDialog: false,
    submitting: false
  }),
  computed: {
    terminationTimerJob() {
      const jobs = this.processData.currentJobs;
      if (!Array.isArray(jobs) || jobs.length === 0) return false;
      return jobs.find(
        (j) =>
          j.jobHandlerConfiguration === CAMUNDA.WAIT_FOR_TERMINATION_TIMER_ID
      );
    },
    disabled() {
      return !this.terminationTimerJob;
    }
  },
  methods: {
    async rejectTerminationProcess() {
      this.submitting = true;

      const path = `contracts/withdrawal/revokeTermination/${this.processData.processInstanceId}/${this.terminationTimerJob.id}`;

      HTTP.delete(path)
        .then(() => {
          this.showMessage('Die Kündigung wurde erfolgreich storniert');
          this.$emit('onSuccess');
        })
        .catch(() => {
          this.showError(
            'Die Kündigung konnte nicht storniert werden, es ist ein Fehler aufgetreten'
          );
        })
        .finally(() => {
          this.submitting = false;
          this.$refs.dateModal.$data.modalActive = false;
        });
    },
    showError: function (message) {
      this.showMessage(message, 'error');
    },
    showMessage: function (description, type = 'success') {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, description)
      );
    }
  }
};
</script>
